<template>
  <div class="py-4 container-fluid">
    <div class="card">
      <div class="card-header py-3">
        <div class="row align-items-center">
          <div class="col-4">
            <h5 class="mb-0">Permissions</h5>
          </div>
          <div class="col-4 d-flex justify-content-center">
            <IconField class="w-100">
              <InputIcon>
                <i class="pi pi-search"></i>
              </InputIcon>
              <InputText
                v-model="table.search"
                type="text"
                size="small"
                placeholder="Search"
                class="rounded-pill w-100"
                @keyup="filter"
              />
            </IconField>
          </div>
        </div>
      </div>
      <DataTable :value="table.onLoad ? dummyRows : table.filteredData" size="null" removable-sort scrollable scroll-height="450px" table-style="min-width: 50rem">
        <Column field="name" header="Name" header-class="bg-light text-dark" sortable>
          <template v-if="table.onLoad" #body>
            <Skeleton></Skeleton>
          </template>
          <template v-else #body="slotProps">
            {{ slotProps.data.name }}
          </template>
        </Column>
        <Column field="guard_name" header="Guard Name" header-class="bg-light text-dark" sortable>
          <template v-if="table.onLoad" #body>
            <Skeleton></Skeleton>
          </template>
          <template v-else #body="slotProps">
            {{ slotProps.data.guard_name }}
          </template>
        </Column>
        <Column field="created_at" header="Created At" header-class="bg-light text-dark" sortable>
          <template v-if="table.onLoad" #body>
            <Skeleton></Skeleton>
          </template>
          <template v-else #body="slotProps">
            {{ slotProps.data.created_at }}
          </template>
        </Column>
        <Column field="updated_at" header="Updated At" header-class="bg-light text-dark" sortable>
          <template v-if="table.onLoad" #body>
            <Skeleton></Skeleton>
          </template>
          <template v-else #body="slotProps">
            {{ slotProps.data.updated_at }}
          </template>
        </Column>
      </DataTable>
      <div class="card-footer pb-0 d-flex justify-content-between align-items-center">
        <BasePagination
          v-model="table.page.current_pages"
          :page-count="table.page.total_pages || 1"
          size="sm"
          @click="changePage()"
        />
        <p>
          {{ (table.page.current_pages - 1) * table.page.per_pages + table.filteredData.length }} dari {{ table.total }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import BasePagination from "@/components/BasePagination.vue";
import api from "@/helpers/api";
import managePermissionService from "@/services/manageAccount/managePermissionService";

export default {
  components: { BasePagination },
  data() {
    return {
      table: {
        onLoad: true,
        search: this.$route.query.search || "",
        total: 0,
        data: [],
        filteredData: [],
        limit: 10,
        page: {
          current_pages: 1,
          per_pages: 10,
          total_pages: 1,
        },
        loadTimeout: null,
      },
      dummyRows: Array.from({ length: 10 }, () => ({})),
    };
  },
  mounted() {
    this.get();
  },
  methods: {
    async get() {
      this.table.onLoad = true;
      try {
        const response = await api(this, managePermissionService.listAll(), false);
        const allData = response.data || [];
        this.table.data = allData;
        this.applyFilter();
      } catch (error) {
        this.table.data = [];
        this.table.filteredData = [];
        this.table.total = 0;
        this.table.page.total_pages = 1;
      } finally {
        this.table.onLoad = false;
      }
    },
    applyFilter() {
      let filtered = this.table.data;
      if (this.table.search) {
        const search = this.table.search.toLowerCase();
        filtered = filtered.filter(item =>
          item.name.toLowerCase().includes(search) ||
          (item.guard_name && item.guard_name.toLowerCase().includes(search))
        );
      }
      this.table.total = filtered.length;
      this.table.page.total_pages = Math.ceil(filtered.length / this.table.limit) || 1;
      const start = (this.table.page.current_pages - 1) * this.table.limit;
      const end = start + this.table.limit;
      this.table.filteredData = filtered.slice(start, end);
    },
    filter() {
      clearTimeout(this.table.loadTimeout);
      this.table.loadTimeout = setTimeout(() => {
        this.$router.push({ query: this.table.search ? { search: this.table.search } : null });
        this.table.page.current_pages = 1;
        this.applyFilter();
      }, 500);
    },
    changePage() {
      this.applyFilter();
    },
  },
};
</script>
  